import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Login from "../components/Login";
import Index from "../components/Index";
import Major from "../components/Major";

export default new Router({
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login
        }, {
            path: '/',
            name: 'index',
            component: Index
        }, {
            path: '/major',
            name: 'major',
            component: Major
        },

    ]
})
